import * as yup from 'yup';
import { assetManagerUrl } from 'configs';


export const validationSchema = yup.object({
  provider_section: yup.object({
    'store_info/about_us_page/provider_image': yup
      .string()
      .when('store_info/about_us_page/is_provider_section_enabled', {
        is: (value) => Number(value) === 1,
        then: yup
          .string()
          .test('store_info/about_us_page/provider_image',
            `Link is not valid, please enter a link from Asset Manager (${assetManagerUrl})`,
            (value) => {
              if (value) {
                return value.includes(assetManagerUrl);
              }

              return true;
            }
          )
          .required('Field is required')
      }),
    'store_info/about_us_page/provider_main_heading': yup
      .string()
      .when('store_info/about_us_page/is_provider_section_enabled', {
        is: (value) => Number(value) === 1,
        then: yup
          .string()
          .required('Field is required')
      }),
    'store_info/about_us_page/provider_content': yup
      .string()
      .when('store_info/about_us_page/is_provider_section_enabled', {
        is: (value) => Number(value) === 1,
        then: yup
          .string()
          .required('Field is required')
      })
  }),
  cta_full_section: yup.object({
    'store_info/about_us_page/cta_full_background_image': yup
      .string()
      .when('store_info/about_us_page/is_cta_full_enabled', {
        is: (value) => Number(value) === 1,
        then: yup
          .string()
          .test('store_info/about_us_page/cta_full_background_image',
            `Link is not valid, please enter a link from Asset Manager (${assetManagerUrl})`,
            (value) => {
              if (value) {
                return value.includes(assetManagerUrl);
              }

              return true;
            }
          )
          .required('Field is required')
      }),
    'store_info/about_us_page/cta_full_content': yup
      .string()
      .when('store_info/about_us_page/is_cta_full_enabled', {
        is: (value) => Number(value) === 1,
        then: yup
          .string()
          .required('Field is required')
      })
  }),
  cta_container_section: yup.object({
    'store_info/about_us_page/cta_container_front_image': yup
      .string()
      .when('store_info/about_us_page/is_cta_container_enabled', {
        is: (value) => Number(value) === 1,
        then: yup
          .string()
          .test('store_info/about_us_page/cta_container_front_image',
            `Link is not valid, please enter a link from Asset Manager (${assetManagerUrl})`,
            (value) => {
              if (value) {
                return value.includes(assetManagerUrl);
              }

              return true;
            }
          )
          .required('Field is required')
      }),
    'store_info/about_us_page/cta_container_back_image': yup
      .string()
      .when('store_info/about_us_page/is_cta_container_enabled', {
        is: (value) => Number(value) === 1,
        then: yup
          .string()
          .test('store_info/about_us_page/cta_container_back_image',
            `Link is not valid, please enter a link from Asset Manager (${assetManagerUrl})`,
            (value) => {
              if (value) {
                return value.includes(assetManagerUrl);
              }

              return true;
            }
          )
          .required('Field is required')
      }),
    'store_info/about_us_page/cta_container_content': yup
      .string()
      .when('store_info/about_us_page/is_cta_container_enabled', {
        is: (value) => Number(value) === 1,
        then: yup
          .string()
          .required('Field is required')
      })
  }),
});

